<script setup lang="ts">
import { useCssModule } from "vue";

import Modal from "@/components/modal/modal.vue";
import StepsButtons from "@/components/StepsButtons/StepsButtons.vue";
import { useTIWStore } from "@/stores/tiw/tiw";

const classes = useCssModule();

const TIWStore = useTIWStore();

const headerText = TIWStore.IS_DISCOUNT_LATER
    ? "Zamówienie przyjęte - przekaż urządzenie kurierowi"
    : "Gotowe - przekaż urządzenie kurierowi";
const headerSubtext = TIWStore.IS_DISCOUNT_LATER
    ? "Potwierdzenie i dalsze instrukcje wysłaliśmy na Twój adres e-mail."
    : "Kartę Podarunkową i dalsze instrukcje wysłaliśmy na Twój adres e-mail.";

function onClick() {
    const EURO_URL = "https://www.euro.com.pl/";
    window.location.assign(EURO_URL);
}
</script>

<template>
    <!-- FIXME перевод -->
    <Modal>
        <template #header>
            <div :class="classes.header">
                <img
                    src="\img\success.svg"
                    alt="thanks for order icon"
                    width="90px"
                    height="90px"
                    :class="classes.icon"
                />
                <h2 class="tiw__h2">{{ headerText }}</h2>
                <p>{{ headerSubtext }}</p>
            </div>
        </template>

        <div>
            <b>Następne kroki:</b>

            <ul :class="classes.nextSteps">
                <template v-if="TIWStore.IS_DISCOUNT_LATER">
                    <li>Wyczyść dane i zapakuj urządzenie zgodnie z instrukcją.</li>
                    <li>Przekaż urządzenie kurierowi w wybranym dniu.</li>
                    <li>
                        Poczekaj na wynik oceny (do 7 dni roboczych od dostarczenia urządzenia).
                    </li>
                    <li>Potwierdź wycenę zgodnie z instrukcją w e-mailu.</li>
                    <li>
                        Otrzymasz Kartę Podarunkową e-mailem. Kartę możesz wykorzystać na
                        euro.com.pl lub w sklepie stacjonarnym.
                    </li>
                </template>

                <template v-else>
                    <li>Wyczyść dane i zapakuj urządzenie zgodnie z instrukcjami.</li>
                    <li>Przekaż urządzenie kurierowi w wybranym dniu.</li>
                    <li>
                        Kartę Podarunkową możesz wykorzystać od razu - na euro.com.pl lub w sklepie
                        stacjonarnym.
                    </li>
                </template>
            </ul>
        </div>

        <StepsButtons no-back-btn :click-to-next="onClick" btn-text="Wykorzystaj kartę teraz" />
    </Modal>
</template>

<style module>
.header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    p {
        text-align: center;
    }
}
.icon {
    margin-bottom: 14px;
}
.nextSteps {
    padding: 0;
    list-style-position: inside;
}
</style>
